import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined';
import { ReactNode } from 'react';
import clsx from 'clsx';

import { OpTooltip } from '../OpTooltip/OpTooltip';

import './OpInfoTooltip.scss';

interface OpInfoTooltipProps {
  title: ReactNode;
  className?: string;
}

export const OpInfoTooltip = ({ title, className }: OpInfoTooltipProps) => {
  return (
    <OpTooltip className={clsx('op-info-tooltip', className)} title={title}>
      <QuestionCircleOutlined className="op-info-tooltip__icon" />
    </OpTooltip>
  );
};
